/**
 * Created by AlexanderC on 01/25/17.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let ClientJS = function ClientJS() {};

if (typeof window !== 'undefined') {
  require('clientjs');
  ClientJS = window.ClientJS;
}

const singletonInstance = Symbol();
const singletonEnforcer = Symbol();

let ClientSession = exports.ClientSession = function (_ClientJS) {
  _inherits(ClientSession, _ClientJS);

  /**
   * @param {Symbol} enforcer
   */
  function ClientSession(enforcer) {
    _classCallCheck(this, ClientSession);

    if (enforcer !== singletonEnforcer) {
      throw new Error('Cannot construct new ClientSession instance');
    }

    var _this = _possibleConstructorReturn(this, (ClientSession.__proto__ || Object.getPrototypeOf(ClientSession)).call(this));

    _this._sessionId = _this._buildSessionId();
    return _this;
  }

  /**
   * @param {String} defaultValue
   *
   * @returns {String}
   */


  _createClass(ClientSession, [{
    key: 'getSitePlatform',
    value: function getSitePlatform() {
      let defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'custom';

      const metaGenerator = this._findMetaContent('generator');

      if (metaGenerator.length <= 0) {
        return defaultValue;
      }

      for (let meta of metaGenerator) {
        for (let name in this._cmsMapping) {
          if (!this._cmsMapping.hasOwnProperty(name)) {
            continue;
          } else if (this._cmsMapping[name].test(meta)) {
            return name;
          }
        }
      }

      return defaultValue;
    }

    /**
     * @returns {*}
     *
     * @private
     */

  }, {
    key: '_findMetaContent',


    /**
     * @param {String} name
     * @param {Boolean} lowercase
     *
     * @returns {String[]}
     * 
     * @private
     */
    value: function _findMetaContent(name) {
      let lowercase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!document || typeof document.getElementsByTagName !== 'function') {
        return [];
      }

      name = (name || '').toLowerCase();

      return this._htmlCollectionToArray(document.getElementsByTagName('meta')).filter(meta => {
        return (meta.getAttribute('name') || '').toLowerCase() === name || (meta.getAttribute('property') || '').toLowerCase() === name;
      }).map(meta => {
        const content = meta.getAttribute('content') || '';

        return lowercase ? content.toLowerCase() : content;
      });
    }

    /**
     * @param {HTMLCollection|*} collection
     *
     * @returns {Array}
     * 
     * @private
     */

  }, {
    key: '_htmlCollectionToArray',
    value: function _htmlCollectionToArray(collection) {
      let result = [];

      for (let i = 0; i < collection.length; i++) {
        result.push(collection[i]);
      }

      return result;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'getSessionId',
    value: function getSessionId() {
      return this._sessionId;
    }

    /**
     * @returns {ClientSession|*} singletonInstance
     */

  }, {
    key: '_buildSessionId',


    /**
     * @returns {String}
     *
     * @private
     */
    value: function _buildSessionId() {
      const fp = this.getFingerprint();

      return `${fp}${Date.now()}`.match(/.{1,6}/g).join('-');
    }
  }, {
    key: '_cmsMapping',
    get: function get() {
      return {
        'contao': /Contao/i,
        'wordpress': /WordPress/i,
        'joomla': /Joomla/i,
        'drupal': /Drupal/i,
        'typo3': /TYPO3/i
      };
    }
  }], [{
    key: 'instance',
    get: function get() {
      if (!this[singletonInstance]) {
        this[singletonInstance] = new ClientSession(singletonEnforcer);
      }

      return this[singletonInstance];
    }
  }]);

  return ClientSession;
}(ClientJS);


//////////////////
// WEBPACK FOOTER
// ../~/deep-event/lib.compiled/Context/Frontend/ClientSession.js
// module id = 381
// module chunks = 0